import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MxDateTimeModule } from '@marxa/devkit';
import { MaterialModule } from '../shared/material.module';
import { MxCrudPanel, MxAddPanel } from './components/mx-crud-panel/mx-crud-panel.component';



@NgModule({
  declarations: [
    MxCrudPanel,
    MxAddPanel
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MxDateTimeModule
  ],
  exports: [
    MxCrudPanel,
    MxAddPanel
  ]
})
export class MxCrudPanelModule { }
